import type { MenuConfig } from '~typings/menu'

import permisosCompras, { RESOURCE_COMPRAS } from '@/auth/permissions/modules/compras'
import * as names from '@routes/compras/nombres/mantenimiento'

const { mantenimiento } = permisosCompras
export default [
    {
        title: 'compras.subopciones.categoria_servicio',
        route: names.ROUTE_CATEGORIAS_SERVICIO,
        resource: RESOURCE_COMPRAS,
        action: mantenimiento.categoriasServicio,
    },
    {
        title: 'compras.subopciones.jefes_area',
        route: names.ROUTE_JEFE_AREA,
        resource: RESOURCE_COMPRAS,
        action: mantenimiento.jefeArea,
    },
    {
        title: 'compras.subopciones.linea_servicio',
        route: names.ROUTE_LINEAS_SERVICIO,
        resource: RESOURCE_COMPRAS,
        action: mantenimiento.lineasServicio,
    },
    {
        title: 'compras.subopciones.plantilla_solicitud',
        route: names.ROUTE_PLANTILLAS_SOLICITUD,
        resource: RESOURCE_COMPRAS,
        action: mantenimiento.plantillasSolicitud,
    },
    {
        title: 'compras.subopciones.servicios',
        route: names.ROUTE_SERVICIOS,
        resource: RESOURCE_COMPRAS,
        action: mantenimiento.servicios,
    },
] as MenuConfig[]
